export default __webpack_public_path__ + "0a307022674a8807aacb984d230ed9a6.png";